import { createStore } from "zustand/vanilla";

/**
 * Posiciones de tarjetas del corcho (UI pura — NO es estado de dominio: qué
 * está fijado vive en el engine; dónde quedó cada tarjeta es layout).
 * Se serializa junto al layout de ventanas en el save (F0-T15).
 */

export interface CardPos {
  x: number;
  y: number;
}

interface CorchoLayoutState {
  positions: Record<string, CardPos>;
  setPos: (cardId: string, pos: CardPos) => void;
}

export const corchoLayout = createStore<CorchoLayoutState>()((set) => ({
  positions: {},
  setPos: (cardId, pos) => set((s) => ({ positions: { ...s.positions, [cardId]: pos } })),
}));

/** Posición por defecto: rejilla en cascada según orden de fijado */
export function defaultPos(index: number): CardPos {
  const col = index % 3;
  const row = Math.floor(index / 3);
  return { x: 24 + col * 220 + row * 16, y: 24 + row * 150 };
}
